import React, { Suspense, lazy } from 'react';
import AuthProvider from 'api/context';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Main from 'Main';

// CRM Frontend Application - Version bump for release

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './App.css';
import { initializeFaroTracing } from './tracing';

const IFrame = lazy(() => import('IFrame'));

const IFRAME_DOCS_BASE_PATH = '/api/v2/docs/iframe';
const IFRAME_DOC_SECTIONS = new Set([
  'overview',
  'latest-updates',
  'iframe-element',
  'general-methods',
  'proposal-methods',
  'designer-methods',
  'ui-methods',
  'shortcuts',
  'error-callbacks',
  'rest-api',
  'conclusion',
  'sample-code',
]);

const IframeApiDocsRedirect = ({ match, location }) => {
  const requestedSection = match?.params?.doc || 'overview';
  const section = IFRAME_DOC_SECTIONS.has(requestedSection)
    ? requestedSection
    : 'overview';
  const target = `${IFRAME_DOCS_BASE_PATH}/${section}${location?.search || ''}${
    location?.hash || ''
  }`;

  React.useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <main role="main" style={{ padding: '2rem' }}>
      <p>Opening the Aerialytic Developer Portal…</p>
      <a href={target}>Continue to the documentation</a>
    </main>
  );
};

const App = () => {
  React.useEffect(() => {
    // Initialize Faro tracing on app startup
    initializeFaroTracing();
  }, []);
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Switch>
          <Route path="/iframe/:uid?" component={IFrame} />
          <Route
            path="/documentation/iframe-api/:doc?"
            component={IframeApiDocsRedirect}
          />
          <Route>
            <AuthProvider>
              <Main />
            </AuthProvider>
          </Route>
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
